<ul *ngIf="options?.length" [class.ordered-list]="type === 'ordered'">
	<ng-container *ngFor="let option of options; let i = index;">
		<li *ngIf="limit && i < limit">
			{{ option.label }}
		</li>
	</ng-container>
	<li *ngIf="limit && options.length > limit">
		<em class="more-items">
			{{ options.length - limit }} {{ (options.length - limit === 1 ? 'MORE_ITEM' : 'MORE_ITEMS') | translate | lowercase }}
		</em>
	</li>
</ul>
<ul *ngIf="!options?.length">
	<li>
		<em>
			{{ 'NO_ITEMS_YET' | translate }}
		</em>
	</li>
</ul>
